import React from "react";

const EtTrinityLogChallengesIntent = ({ userId, onClose }) => {
  
  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Prompt user to capture key challenges or intent

  return (
    <div className="p-4">
      <h3 className="text-lg font-bold text-gray-800 mb-2">Log Challenges & Intent</h3>
      <p className="text-sm text-gray-600 mb-2">[Prompt user to jot down 1–2 challenges and an intention for tomorrow]</p>
      <button
        onClick={onClose}
        className="mt-4 text-sm text-blue-600 underline"
      >
        Close
      </button>
    </div>
  );
};

export default EtTrinityLogChallengesIntent;
